import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { strings } from '/imports/strings';
import { PublicFooter } from '/imports/ui/PublicFooter';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';
import { Logo } from '/imports/ui/Logo';

export const SignupSubmittedPageStyled = SignedOutPageStyled;

export const SignupSubmittedPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = window.atob(params.get('email') || '');
  return (
    <SignupSubmittedPageStyled className="page">
      <div className="wrapper">
        <div className="inner-wrapper">
          <div><Logo size={2} /></div>
          <div>
            <h2>{strings.SignUp()}</h2>
            <div>{strings.ThankYouForSigningUpMessage(email)}</div>
          </div>
          <span>
            <Link className="login-link" to='/login'>{strings.GoToLogin()}</Link>
          </span>
        </div>
      </div>
      <PublicFooter />
    </SignupSubmittedPageStyled>
  );
};
